// Placeholder for the platform-admin home. The full overview (recent
// audit events, quick org search, deploy status) is post-v1.

import { Link } from "react-router-dom";

export function AdminOverview() {
  return (
    <div className="page">
      <div className="page-pad">
        <header className="page-header">
          <div className="page-header__lead">
            <div className="page-header__eyebrow">Platform admin</div>
            <h1 className="page-header__title">Panel interno</h1>
            <p className="page-header__sub">
              Provisioning de organizaciones, invitaciones cross-org y carga masiva. Las acciones
              aquí afectan cualquier organización en la plataforma — revisa dos veces antes de
              confirmar.
            </p>
          </div>
        </header>
        <section className="panel">
          <div className="panel__head">
            <h2 className="panel__title">Acciones</h2>
          </div>
          <div className="panel__body--flush">
            <ul className="stack-gap" style={{ padding: "16px 18px" }}>
              <li>
                <Link to="/admin/orgs" className="btn btn--brand-ghost">
                  Listar / crear organizaciones
                </Link>
              </li>
              <li>
                <Link to="/admin/carga-masiva" className="btn btn--brand-ghost">
                  Subir planilla xlsx
                </Link>
              </li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
}
